// extracted by mini-css-extract-plugin
module.exports = {"loaderWrap":"Balance_loaderWrap__3I2Dv","balanceWrap":"Balance_balanceWrap__3fVFP","type":"Balance_type__1XQel"};